import React, { useState } from "react";
import AddNewSupplierPage from "../../../../../entities/DashboardPage/AccountingModule/Supplier/AddNewSupplier";
import AuthService from "../../../../../api/AuthService";
import { useNavigate } from "react-router-dom";

import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../../../context/AlertContext";

const AddNewSupplier = () => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleAddNewSupplier = async (payload) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.handleSupplier(payload);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/supplier")
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
      showAlert(error, "error");
    }
  };
  return (
    <AddNewSupplierPage handleAddNewSupplier={handleAddNewSupplier} loading={loading} />
  )

}

export default AddNewSupplier;
